import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useFormContext, useWatch } from "react-hook-form";
import ReactJson from "@microlink/react-json-view";

function Prices() {
  const { register } = useFormContext();
  const watchPricesData = useWatch({ name: "prices" });
  return (
    <Card style={{ maxWidth: 800 }}>
      <CardBody style={{ padding: 16 }}>
        <input {...register("prices")} type={"hidden"} />
        {typeof watchPricesData === "object" && watchPricesData != null ? (
          <ReactJson collapsed={true} src={watchPricesData} />
        ) : null}
      </CardBody>
    </Card>
  );
}

export default Prices;
